// ----------------------------------------------------------------------------------------------
// --------------------------- pdp size chart popup button -------------------------------------
let popupSizeChartTrigger = document.querySelector("[data-size-popup-trigger]");
let popupSizeChartEl = document.querySelector(".product-size-chart__popup");
let popupSizeChartImgEl = document.querySelector(
  ".product-size-chart__popup-img"
);
let popupSizeChartImgSrcEl = document.querySelector("[data-size-popup-source]");
let popupSizeChartImgSrc;

if (popupSizeChartImgSrcEl) {
  popupSizeChartImgSrc = popupSizeChartImgSrcEl.getAttribute(
    "data-size-popup-source"
  );
}

let overlaySizeChartEl = document.querySelector(".product-size-chart__overlay");
let popupSizeChartCloseEl = document.querySelector("[data-size-popup-close]");
if (popupSizeChartTrigger) {
  popupSizeChartTrigger.addEventListener("click", openSizeChartPopup);
  overlaySizeChartEl.addEventListener("click", closeSizeChartPopup);
  popupSizeChartCloseEl.addEventListener("click", closeSizeChartPopup);
}

function updateSizeChartSource() {
  if (popupSizeChartImgSrc) {
    popupSizeChartImgEl.src = popupSizeChartImgSrc;
  } else {
    popupSizeChartImgEl.style.display = "none";
  }
}
function openSizeChartPopup() {
  updateSizeChartSource();
  popupSizeChartEl.classList.add("is-open");
  document.documentElement.classList.add("prevent-scroll");
}
function closeSizeChartPopup() {
  popupSizeChartEl.classList.remove("is-open");
  document.documentElement.classList.remove("prevent-scroll");
}

// ----------------------------------------------------------------------------------------------
// --------------------------- pdp app widget - pick color image popup button -------------------------------------
let textColorPickerNode = document.querySelector(".tee-colorpicker");
let newPopupTriggerNode = document.createElement("span");

function confirmNodeInDom() {
  textColorPickerNode = document.querySelector(".tee-colorpicker");
  if (textColorPickerNode) {
    clearInterval(intervalId);
    addPopupBtnNode();
  }
}

const intervalId = setInterval(confirmNodeInDom, 500);

function addPopupBtnNode() {
  textNode = document.createTextNode("Retro Number Colours");
  newPopupTriggerNode.classList.add("text-color-popup-trigger");
  newPopupTriggerNode.setAttribute("data-text-color-popup-trigger", "");
  newPopupTriggerNode.appendChild(textNode); // Correcting the usage
  textColorPickerNode.appendChild(newPopupTriggerNode);
  newPopupTriggerNode.classList.add("revealed");

  setupPopupFortextColorPicker();
}

function setupPopupFortextColorPicker() {
  let popupTextColorChartTrigger = document.querySelector(
    "[data-text-color-popup-trigger]"
  );
  let popupTextColorChartEl = document.querySelector(
    ".product-app-text-colors-chart__popup"
  );
  let popupTextColorChartImgEl = document.querySelector(
    ".product-app-text-colors-chart__popup-img"
  );
  let popupTextColorChartImgSrcEl = document.querySelector(
    "[data-text-color-chart-popup-source]"
  );
  let popupTextColorChartImgSrc;

  if (popupTextColorChartImgSrcEl) {
    popupTextColorChartImgSrc = popupTextColorChartImgSrcEl.getAttribute(
      "data-text-color-chart-popup-source"
    );
  }

  let overlayTextColorChartEl = document.querySelector(
    ".product-app-text-colors-chart__overlay"
  );
  let popupTextColorChartCloseEl = document.querySelector(
    "[data-text-color-chart-close]"
  );
  if (popupTextColorChartTrigger) {
    popupTextColorChartTrigger.addEventListener(
      "click",
      openTextColorChartPopup
    );
    overlayTextColorChartEl.addEventListener("click", closeTextColorChartPopup);
    popupTextColorChartCloseEl.addEventListener(
      "click",
      closeTextColorChartPopup
    );
    updateTextColorChartSource();
  }

  function updateTextColorChartSource() {
    if (popupTextColorChartImgSrc) {
      popupTextColorChartImgEl.src = popupTextColorChartImgSrc;
    } else {
      popupTextColorChartImgEl.style.display = "none";
    }
  }
  function openTextColorChartPopup() {
    popupTextColorChartEl.classList.add("is-open");
    document.documentElement.classList.add("prevent-scroll");
  }
  function closeTextColorChartPopup() {
    popupTextColorChartEl.classList.remove("is-open");
    document.documentElement.classList.remove("prevent-scroll");
  }
}

// ----------------------------------------------------------------------------------------------
// -------------- mobile menu: make top-level label toggle its submenu ----------------
document.addEventListener("DOMContentLoaded", (event) => {
  // Only affect top-level mobile items where the label is a non-link button
  const topLevelLabelAnchors = document.querySelectorAll(
    '.sf-menu-wrapper-mobile .sf-menu-links > .sf-link > div > a[role="button"]'
  );

  topLevelLabelAnchors.forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Toggle the same dropdown as the icon (.custom-sf-link-submenu-show-hide-toggle)
      const mainMenuItem = anchor.closest(".sf-link");
      if (!mainMenuItem) return;

      const toggleBtn = mainMenuItem.querySelector(
        ".custom-sf-link-submenu-show-hide-toggle"
      );
      if (toggleBtn) {
        toggleBtn.click();
      }
    });
  });

  // Make 2nd-level menu labels that HAVE submenus open their side panel instead of navigating
  const secondLevelAnchors = document.querySelectorAll(
    '.sf-menu-wrapper-mobile .sf-sub-links--level-2 > .sf-link > a.w-full'
  );

  secondLevelAnchors.forEach((anchor) => {
    // Only modify behavior if this 2nd-level item actually has a submenu toggle
    const menuItem = anchor.closest(".sf-link");
    if (!menuItem) return;

    const secondLevelToggle = menuItem.querySelector(
      '.sf__toggle-submenu-mb[data-toggle-submenu="1"]'
    );
    if (!secondLevelToggle) return;

    anchor.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      secondLevelToggle.click();
    });
  });

  // -------------- updating pdp variant picker when sticky variant picker changed ----------------
  if (document.location.href.includes("products")) {
    // Utility function to set picker fields
    function setPickerField(field, value) {
      field.setAttribute("data-selected-value", value);
      if (field.getAttribute("data-picker-field") == "radio") {
        field.querySelector(
          `input[type="radio"][value="${value}"]`
        ).checked = true;
      }
      const selectEl = field.querySelector("select");
      if (selectEl) {
        selectEl.value = value;
      }
    }

    // Utility function to parse option text
    function parseOptionText(optionText) {
      return optionText.split("-")[0].trim().split("/");
    }

    const productWrapperEl = document.querySelector(".sf-prod-template");
    const variantPicker = productWrapperEl.querySelector("variant-picker");
    const variantPickerFieldEls = productWrapperEl.querySelectorAll(
      "[data-picker-field]"
    );
    const stickyATC = document.querySelector("sticky-atc");
    const stickyATCSelectEl = stickyATC.querySelector('select[name="id"]');

    stickyATCSelectEl.addEventListener("change", () => {
      const selectedOption = stickyATCSelectEl[stickyATCSelectEl.selectedIndex];
      const selectedOptionVariantName =
        selectedOption.getAttribute("data-variant-name");
      const selectedOptionOptionNames = parseOptionText(
        selectedOptionVariantName
      );

      const hasTeeAppNodeInDOM = document.querySelector("#tee-artwork-form");
      if (!hasTeeAppNodeInDOM) {
        selectedOptionOptionNames.forEach((value, index) => {
          if (variantPickerFieldEls[index]) {
            setPickerField(variantPickerFieldEls[index], value.trim());
          }
        });

        // Dispatch change events
        variantPicker.dispatchEvent(new Event("change", { bubbles: true }));
        const variantPickerAllTypeEls = document.querySelectorAll(
          "variant-select, variant-button, variant-color, variant-image"
        );
        variantPickerAllTypeEls.forEach((el) =>
          el.dispatchEvent(new Event("change", { bubbles: true }))
        );
      }
    });

    // ------------------------------------------------------------------
    // ------------------- for teeinblue app template -------------------
    // Utility function to set picker fields

    // iife - start
    (function () {
      setTimeout(teeInBlueSyncScript, 1000);
      let teeInBlueOptionsNodeInDOM = document.querySelector(".tee-variants");
      if (teeInBlueOptionsNodeInDOM) {
        function teeInBlueSyncScript() {
          let teePDPATCButtonEl = document.querySelector(
            'button#teeAtcButton[type="button"]'
          );
          let allOptionsWrapperEls =
            teeInBlueOptionsNodeInDOM.querySelectorAll(".tee-option");
          let allRadioEls = teeInBlueOptionsNodeInDOM.querySelectorAll(
            '.tee-radio input[type="radio"]'
          );
          let allRadioLabelEls =
            teeInBlueOptionsNodeInDOM.querySelectorAll(".tee-radio-label");
          let allRadioParentEls =
            teeInBlueOptionsNodeInDOM.querySelectorAll(".tee-radio");

          let productWrapperEl = document.querySelector(".sf-prod-template");
          let variantPicker = productWrapperEl.querySelector("variant-picker");
          let variantPickerFieldEls =
            productWrapperEl.querySelectorAll(".tee-option");

          let stickyATC = document.querySelector("sticky-atc");
          let stickyATCSelectEl = stickyATC.querySelector('select[name="id"]');
          let stickyATCSelectOptionEls =
            stickyATCSelectEl.querySelectorAll("option");
          let stickyATCFormNameID = stickyATC.querySelector(
            'input[type="hidden"][name="product-id"]'
          );
          let stickyATCButtonEl = stickyATC.querySelector(
            'button[type="submit"][name="add"]'
          );

          allRadioLabelEls.forEach((el) =>
            el.addEventListener("click", () => {
              let sameOptionPDPField = el.closest(".tee-option");
              if (sameOptionPDPField) {
                let sameOptionPDPFieldRadioWrs =
                  sameOptionPDPField.querySelectorAll(".tee-radio");
                sameOptionPDPFieldRadioWrs.forEach((el) =>
                  el.classList.remove("active")
                );
                el.parentElement.classList.add("active");
              }
            })
          );

          // ** event - on change of sticky ATC select
          stickyATCSelectEl.addEventListener("change", () => {
            let selectedOption =
              stickyATCSelectEl[stickyATCSelectEl.selectedIndex];
            let selectedOptionOptionsString = selectedOption.getAttribute(
              "data-variant-options"
            );
            let selectedOptionOptionNamesArr = parseOptionText(
              selectedOptionOptionsString
            );

            selectedOptionOptionNamesArr.forEach((value) => {
              setPickerField(teeInBlueOptionsNodeInDOM, value);
            });
          });

          // utility function - to parse option names
          function setPickerField(optionsContainer, value) {
            let sameOptionInPdpPicker = optionsContainer.querySelector(
              `input[type="radio"][value="${value}"]`
            );
            if (sameOptionInPdpPicker) {
              // clicking the same option in pdp
              let sameOptionInPdpPickerLabel =
                sameOptionInPdpPicker.parentElement.querySelector("label");
              let sameOptionInPdpPickerParent =
                sameOptionInPdpPicker.parentElement;

              sameOptionInPdpPicker.click();
              if (sameOptionInPdpPickerLabel) {
                sameOptionInPdpPickerLabel.click();
              }
              if (sameOptionInPdpPickerParent) {
                sameOptionInPdpPickerParent.click();
              }

              // seting selected option value & active the same option in pdp
              let sameOptionPDPField =
                sameOptionInPdpPicker.closest(".tee-option");
              if (sameOptionPDPField) {
                sameOptionPDPField.setAttribute("value", value);
                let sameOptionPDPFieldRadios =
                  sameOptionPDPField.querySelectorAll(".tee-radio");
                sameOptionPDPFieldRadios.forEach((el) =>
                  el.classList.remove("active")
                );
                sameOptionInPdpPickerParent.classList.add("active");
              }
            }
          }
          // utility function - to parse option names
          function parseOptionText(optionText) {
            let varinatOptions = optionText.split("//");
            return varinatOptions;
          }

          // ** event - on change of options radio Els
          let activeVaraintOptionsString;
          allRadioEls.forEach((el) =>
            el.addEventListener("change", () => {
              activeVaraintOptionsString = "";

              setTimeout(() => {
                getVaraintOptionsString();
                setStickyATCSelctAndVariantID();
                scrollToClickedRadioEl(el);
              }, 500);
            })
          );

          // utility function - getting active options variant string
          function getVaraintOptionsString() {
            allOptionsWrapperEls.forEach((optionWrapper, i) => {
              let selectedOptionInput = optionWrapper.querySelector(
                '.tee-radio input[type="radio"]:checked'
              );
              let selectedOption = selectedOptionInput.parentElement;
              let selectedOptionValue =
                selectedOption.querySelector("input").value;
              if (i == 0) {
                activeVaraintOptionsString += selectedOptionValue + " / ";
              } else {
                activeVaraintOptionsString += selectedOptionValue;
              }
            });
          }
          // utility function - setting active options variant string
          function setStickyATCSelctAndVariantID() {
            stickyATCSelectOptionEls.forEach((option) => {
              if (
                option
                  .getAttribute("data-variant-name")
                  .includes(activeVaraintOptionsString)
              ) {
                stickyATCSelectEl.value = option.value;
                stickyATCFormNameID.value = option.value;
              }
            });
          }

          // dynamically click PDP tee ATC on sticky atc click
          stickyATCButtonEl.addEventListener("click", (e) => {
            e.preventDefault();
            scrollToClickedRadioEl(teePDPATCButtonEl);
            clickPDPTeeATCBtn();
          });
          function clickPDPTeeATCBtn() {
            teePDPATCButtonEl.click();
          }

          function scrollToClickedRadioEl(el) {
            let elPosition = el.offsetTop;
            window.scrollTo({ top: elPosition, behavior: "smooth" });
          }
        }
      }

      // iife - end
    })();

    // dom event end
  }
});
